import { PrimaryButton, Typo, xlBumps, xxlBumps } from '@wrisk/ui-components'
import React, { FunctionComponent, useCallback } from 'react'
import { Trans } from 'react-i18next'
import { useNavigate } from 'react-router-dom'

import {
  useProposalAdjustment,
  useProposalFormData,
} from '../../../../hooks/adjustments/proposal'
import {
  TExtends,
  TKey,
  useWriskTranslation,
} from '../../../../infrastructure/internationalisation'
import { FormErrors } from '../../../formBuilder'
import { FullPage } from '../../../templates'
import { useProduct } from '../../productContext'
import { ProposalPath } from '../ProposalPath'
import { PageNotification } from './PageNotification'

const tKey = TKey('pages.before-we-begin')

export const BeforeWeBeginPage: FunctionComponent = () => {
  const { t } = useWriskTranslation()
  const navigate = useNavigate()
  const {
    product: { beforeWeBegin },
  } = useProduct()

  const data = useProposalFormData(beforeWeBegin ?? [])

  const onContinue = useCallback(() => navigate(ProposalPath.DISCLOSURE), [navigate])
  const onSubmitAdjustment = useProposalAdjustment({
    inputs: beforeWeBegin ?? [],
    applyRating: false,
    onComplete: onContinue,
  })

  return (
    <FullPage pageId='before-we-begin-page' header={t(tKey('header'))}>
      <PageNotification tKey={tKey} mb={xlBumps} />
      <Typo mb={xxlBumps}>
        <Trans t={t} i18nKey={tKey('content')} />
      </Typo>
      {beforeWeBegin?.length ? (
        <FormErrors
          id='before-we-begin'
          data={data}
          inputs={beforeWeBegin}
          onSubmit={onSubmitAdjustment.execute}
          loading={onSubmitAdjustment.loading}
          tKey={TExtends(tKey, 'form')}
          t={t}
        />
      ) : (
        <PrimaryButton layout='fixed' onClick={onContinue} data-testid='button-confirm'>
          {t('defaults.actions.continue')}
        </PrimaryButton>
      )}
    </FullPage>
  )
}
